import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Unstable_Grid2";
import {
  Autocomplete,
  Chip,
  FormControl,
  FormGroup,
  TextField,
} from "@mui/material";
import { useFormik } from "formik";
import { formFunctions } from "../../../modules/hcmd/components/formUtils";
import moment from "moment";

const UserTagFormForwardRef = (props, ref) => {
  const { formik } = props;

  useImperativeHandle(ref, () => ({
    submit() {
      return formik.values;
    },
  }));

  return (
    <form
      noValidate="novalidate"
      className="form"
      onSubmit={formik.handleSubmit}
    >
      {props.children}
    </form>
  );
};
const UserTagForm = forwardRef(UserTagFormForwardRef);
UserTagForm.propTypes = {
  formik: PropTypes.object,
};

const UserTagForwardRef = (props, ref) => {
  useImperativeHandle(ref, () => formFunctions(formRefs));
  const { user, isEditable, options, site } = props;
  const formRefs = useRef([]);

  // FONTOS: a tag.type konvenció (md=20, hc=10) — NEM a user.type!
  const siteType = site === "md" ? 20 : site === "hc" ? 10 : 0;

  const [selectableTags, setSelectableTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [value, setValue] = useState([]);
  const [open, setOpen] = useState(false);

  const isDense = true;

  const formik = useFormik({
    initialValues: {
      userTags: [],
    },
    onSubmit: (values) => {
      console.log("userTag values", values);
    },
  });

  useEffect(() => {
    if (options.tags?.length) {
      setSelectableTags(
        options.tags.filter(
          (item) =>
            item.type === siteType && item.tagCategories?.scope === "user"
        )
      );

      const selectedItems = [];
      const valueItems = [];
      (user.userTags ?? []).map((item) => {
        const found = options.tags.find((tag) => tag.id === item.tagId);
        if (found) {
          selectedItems.push(found);
          valueItems.push({ ...item, name: found.name });
        }
        setSelectedTags(selectedItems);
        setValue(valueItems);
      });
    }
  }, [options]);

  useEffect(() => {
    formik.setFieldValue(
      "userTags",
      selectedTags.map((item, index) => {
        const tagValue = {
          tagId: item.id,
          createTime: moment().format(),
          updateTime: moment().format(),
        };
        if (value?.[index]?.id) {
          tagValue.id = value?.[index]?.id;
        }
        return tagValue;
      })
    );
  }, [selectedTags]);

  return (
    <Grid container spacing={2}>
      <Grid md={12}>
        <div className={`card ${isDense ? "border-0" : ""}`}>
          <div className={`card-body ${isDense ? "p-4" : "py-3"}`}>
            <div className="collapse show">
              {!isEditable &&
                selectedTags.length > 0 &&
                selectedTags.map((item, index) => (
                  <Chip
                    key={index}
                    className={"me-3"}
                    label={item.name}
                    variant="outlined"
                  />
                ))}
              {!isEditable && selectedTags.length === 0 && (
                <span className="text-muted">Nincs címke</span>
              )}
              {isEditable && (
                <UserTagForm
                  formik={formik}
                  ref={(el) => (formRefs.current[0] = el)}
                >
                  <div className={`card-body ${isDense ? "p-0" : "p-9"}`}>
                    <FormControl component="fieldset" className={"w-100"}>
                      <FormGroup aria-label="userTags" row className={"w-100"}>
                        <Autocomplete
                          id="userTags"
                          className={"w-100"}
                          open={open}
                          onOpen={() => setOpen(true)}
                          onClose={() => setOpen(false)}
                          multiple={true}
                          noOptionsText="Nincs opció"
                          options={selectableTags}
                          isOptionEqualToValue={(option, val) =>
                            option.id === val.id
                          }
                          getOptionLabel={(option) => option.name ?? ""}
                          onChange={(event, val) => {
                            setSelectedTags(val ?? []);
                          }}
                          value={selectedTags}
                          renderInput={(params) => <TextField {...params} />}
                          renderOption={(optionProps, option) => (
                            <li {...optionProps} key={option.id}>
                              {option.name}
                            </li>
                          )}
                        ></Autocomplete>
                      </FormGroup>
                    </FormControl>
                  </div>
                </UserTagForm>
              )}
            </div>
          </div>
        </div>
      </Grid>
    </Grid>
  );
};
const UserTag = forwardRef(UserTagForwardRef);
UserTag.propTypes = {
  user: PropTypes.object.isRequired,
  isEditable: PropTypes.bool.isRequired,
  options: PropTypes.object.isRequired,
  site: PropTypes.string.isRequired,
  onSubmit: PropTypes.func,
};
export default UserTag;
